/**
 * Reusable container styles for consistent layout widths.
 * Use with `cn()` to merge with other classes.
 *
 * @example
 * <main className={cn(container.default, "py-6")}>
 * <div className={container.narrow}>
 */
export const container = {
  /**
   * Constrained through laptop widths (max-w-8xl / 88rem), then full-bleed
   * past 2xl (1536px+) so monitor layouts stop floating in the centre.
   */
  default: "w-full min-w-0 max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 2xl:max-w-none",

  /** Narrower container for forms/content — max-w-3xl (768px) */
  narrow: "w-full max-w-3xl mx-auto px-4 sm:px-6",

  /** Same as default — kept as an alias for call sites that already opt into "wide". */
  wide: "w-full min-w-0 max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 2xl:max-w-none",

  /** Full width with padding only */
  fluid: "w-full px-4 sm:px-6 lg:px-8",
} as const;

/**
 * Container without horizontal padding (for nested use).
 */
export const containerNoPadding = {
  default: "w-full max-w-8xl mx-auto 2xl:max-w-none",
  narrow: "w-full max-w-3xl mx-auto",
  wide: "w-full max-w-8xl mx-auto 2xl:max-w-none",
} as const;
